<div
  class="materials d-flex align-items-end border-bottom no-scrollbar border-top"
>
  <div
    *ngFor="let material of materials; trackBy: trackByProductId"
    class="material d-flex flex-column justify-content-start align-items-center nav-link p-2"
    [class.active]="
      (selectedMaterial$ | async)?.productId === material.productId
    "
    [class.extended-height]="isNowOrder && isAnyRowHasConsignment(materials)"
    (click)="onMaterialClick(material.productId)"
  >
    @if ((componentStore.markVariantInOpenedList$ | async) &&
    componentStore.isListPage() &&
    componentStore.isMaterialInOpenedList(material.productId,
    (componentStore.openedListProductReferences$ | async))) {
    <fa-icon
      class="list-icon text-dark"
      [icon]="['fas', 'tag']"
      [atxTooltip]="variantInOpenedListLocale"
    ></fa-icon>
    }
    <atx-product-image
      class="img-fluid"
      [imageUrl]="material.mainImageUrl"
      [maxWidth]="imageMaxSizes.ICON"
      data-e2e="material-image"
      [product]="material"
      [productImageMissingVisualConfig]="productImageMissingVisualConfig"
    ></atx-product-image>

    <span class="title text-truncate text-center">
      <small>{{ getMaterialTitle(material) }}</small>
    </span>
    <ng-container *ngIf="isNowOrder">
      <div class="mt-2" *ngIf="isRowHasConsignment(material.productId)">
        <span
          class="p-1 px-2 rounded text-uppercase color-bulk bg-bulk"
          i18n="Size Grid|Bulk label@@bulkIndicatorLabel"
        >
          Bulk
        </span>
      </div>
    </ng-container>
    <span
      *ngIf="
        getCustomerProductIdentifier(
          material.productId
        ) as customerProductIdentifier
      "
      class="title text-truncate text-center text-muted font-italic"
    >
      <small>{{ customerProductIdentifier }}</small>
    </span>
  </div>
</div>

<ng-container *ngIf="sizerunsGrid">
  <div
    class="d-flex flex-column mt-3 mx-3"
    *ngrxLet="selectedMaterial$ | async as selectedMaterial"
  >
    <div>
      <span
        i18n="
          Size grid|Size runs with predefined quantities tooltip
          message@@sizeRunsPredefinedQuantitiesTooltip"
      >
        For this style you can add only predefined quantities
      </span>
    </div>
    <epc-size-runs-quantities
      class="mt-1"
      *ngIf="
        !disabledMaterialsIds ||
        !disabledMaterialsIds[selectedMaterial.productId]
      "
      [quantity]="getSizeRunsQuantity(selectedMaterial.productId)"
      [maxQuantity]="getSizeRunsQuantitiesMax(selectedMaterial.productId)"
      (quantityChange)="
        onSizeRunsQuantityChange(selectedMaterial.productId, $event)
      "
      [formControl]="selectedSizeRun"
    ></epc-size-runs-quantities>
    <span
      class="not-full-size-run mt-1"
      *ngIf="sizerunsGrid && hasSomeNotFulfilled(selectedMaterial.productId, 0)"
      i18n="
        Size grid|Size runs some quantities were not available tooltip
        message@@sizeRunsSomeQuantitiesNotAvailableTooltip"
    >
      Some quantities were not available
    </span>
  </div>
</ng-container>

@if (ySizes || scaleSelectorVisible) {
<div class="d-flex border-bottom">
  @if (ySizes) {
  <div
    class="horizontal-sizes d-flex"
    *ngrxLet="selectedYSize$ as selectedYSize"
  >
    @for (ySize of ySizes; track $index) {
    <div
      class="y-size nav-link"
      [class.active]="ySize === selectedYSize"
      (click)="selectedYSize$.next(ySize)"
    >
      <span>{{ ySize }}</span>
    </div>
    }
  </div>
  } @if (scaleSelectorVisible) {
  <epc-scale-selector
    class="align-self-center ml-auto mr-3"
    [scales]="scaleSets"
    [selected]="selectedScale"
    [scaleDisplayObject]="scaleDisplayObject"
    [disabled]="isScaleSelectorDisabled"
    (selectScale)="handleScaleSelection($event)"
  ></epc-scale-selector>
  }
</div>
}

<div
  class="vertical-sizes position-relative d-flex flex-column"
  [formGroup]="selectedMaterialGroup"
  *ngIf="selectedMaterial$ | async as material"
>
  <ng-container *ngFor="let xSize of xSizes; index as i; trackBy: trackByIndex">
    <div
      *ngIf="selectedYSizeGroup.controls[i] as formGroupQuantities"
      class="x-size px-3 py-3 d-flex justify-content-between align-items-center border-bottom"
      [class.active]="isCellActive(xSize)"
      [formGroup]="formGroupQuantities"
      (click)="selectCell(xSize)"
    >
      <span
        [class.not-full-size-run]="
          sizerunsGrid &&
          isRequestedMoreThenAvailable(
            material.productId,
            selectedYSizeIndex,
            getXIndex(xSize)
          )
        "
        >{{ xSize }}</span
      >
      <div
        class="d-flex align-items-center"
        *ngIf="{ inventoryObj: getCellInventories(xSize) } as cellData"
      >
        <div class="d-flex flex-column">
          <ng-container
            *ngIf="getMaterialDiscount(material.productId) as discount"
          >
            @if((discount?.max || 0) > 0) {
            <atx-discount-label
              *atxCanShowByWsp
              [discount]="discount"
              class="py-1 mr-4 mb-1 text-success text-center d-flex align-items-center justify-content-center"
            ></atx-discount-label>
            }
          </ng-container>
        </div>
        <ng-container *ngIf="isNowOrder">
          <div class="d-flex flex-column" *ngIf="isSizeHasConsignment(xSize)">
            <div
              class="bg-bulk rounded-circle mr-3"
              style="width: 10px; height: 10px"
            ></div>
          </div>
        </ng-container>
        <atx-clikable-amount-input
          *ngIf="!(material.isLocked || !cellData.inventoryObj.totals)"
          [max]="
            skipInventoryCheck || cellData.inventoryObj.hasTrueDemandInventory
              ? maxUnlimitedQuantityOrder
              : min(cellData.inventoryObj.totals, maxUnlimitedQuantityOrder)
          "
          [currentValue]="formGroupQuantities.get('quantity')?.value"
          [useTemplateForm]="true"
          [isDisabled]="
            sizerunsGrid ||
            (backOrdersOnly(cellData.inventoryObj) &&
              (backOrderNotEnabled$ | async))
          "
          (valueChange)="updateQuantitiesFormGroup(formGroupQuantities, $event)"
        >
          <epc-grid-cell
            [inventory]="cellData.inventoryObj"
            [isLocked]="material.isLocked || !cellData.inventoryObj.totals"
            [inBasketQuantity]="getQuantity(xSize)"
            [showInventoryPlaceholderOnFocus]="false"
            data-e2e="vertical-grid-cell"
            class="h-100 grid-cell position-relative"
            [formControl]="formGroupQuantities.get('quantity')"
            [sizeRunsCell]="sizerunsGrid"
          >
          </epc-grid-cell>
        </atx-clikable-amount-input>
      </div>
      <div
        class="d-flex"
        *ngIf="
          disabledMaterialsIds &&
          disabledMaterialsIds[material.productId] as disabledData
        "
      >
        <div class="unavailable disabled ml-3">
          <span
            i18n="
              Size Grid|Unavailable material label@@unavailableMaterialLabel"
            >This color is unavailable for selected date
          </span>
          <div
            class="d-flex align-items-center flex-column flex-sm-row"
            *ngIf="showNextAvailableDate"
          >
            <ng-container *ngIf="disabledData.future">
              <ng-container
                i18n="
                  Size Grid|Next available date label@@nextAvailableDateLabel"
              >
                Next available date:
              </ng-container>
              <button
                class="btn py-0 pl-1 d-flex"
                *ngIf="disabledData.future"
                (click)="selectPeriod(disabledData.future)"
              >
                <epc-delivery-period-date-label
                  [intervalType]="deliveryWindowType"
                  [deliveryData]="disabledData.future"
                ></epc-delivery-period-date-label>
              </button>
            </ng-container>
            <button
              class="btn p-0"
              *ngIf="disabledData.hasNow && !disabledData.future"
              (click)="selectNow()"
              i18n="Size Grid|Next available now label@@nextAvailableNowLabel"
            >
              Switch to Now
            </button>
          </div>
        </div>
      </div>
    </div>

    @if(showInventoryOverview) {
    <epc-inventory-overview
      *ngIf="isCellActive(xSize)"
      [limitVisibleInventories]="1"
      class="sticky-right border-bottom"
    ></epc-inventory-overview>
    }
  </ng-container>

  <div
    *ngIf="material.isLocked"
    class="locked-overlay position-absolute d-flex justify-content-center align-items-center"
  >
    <fa-icon [icon]="['fas', 'lock']" size="2x"></fa-icon>
  </div>
</div>
